import { useCallback, useEffect, useState } from 'react';

import { CpeMarker } from '../datasource/generated/models/CpeMarker';
import { ExternalCommand, setExternalCommand } from '../stories/Store/playerSlice';
import { useAppDispatch, useAppSelector } from '.';
import useCpeExams from './useCpeExams';


export const useCpeMarkers = () => {
    const dispatch = useAppDispatch();

    const launchItemSk = useAppSelector((state) => state.player.launchDetails.itemSk);
    const cpeMarkers = useAppSelector((state) => state.player.launchDetails.video?.cpeMarkers);
    const currentSegmentItemSk = useAppSelector((state) => state.player.currentSegmentItemSk);
    const currentSegmentPosition = useAppSelector((state) => state.player.playbackProgress.find(x => x.itemSk === currentSegmentItemSk))?.position ?? 0;

    const { exams } = useCpeExams(false);

    const [activeMarker, setActiveMarker] = useState<CpeMarker | undefined>();

    const [areCpeMarkersReady, setAreCpeMarkersReady] = useState(false);

    const hasCpeMarkers = cpeMarkers && cpeMarkers.length;
    const isCpeSegment = hasCpeMarkers && currentSegmentItemSk === launchItemSk;


    useEffect(() => {
        if (!areCpeMarkersReady || !isCpeSegment || !exams || exams.length === 0)
            return;

        const currentMarker = cpeMarkers.find(m => {
            return Math.floor(m.position ?? 0) === Math.floor(currentSegmentPosition);
        });

        if (currentMarker) {
            dispatch(setExternalCommand(ExternalCommand.pause));
            setActiveMarker(currentMarker);
        }
    }, [areCpeMarkersReady, cpeMarkers, currentSegmentPosition, dispatch, exams, isCpeSegment]);


    const dismissActiveMarker = () => {
        setActiveMarker(undefined);
    };

    const setCpeMarkersReady = useCallback(() => {
        setAreCpeMarkersReady(true);
    }, []);

    return {
        activeCpeMarker: activeMarker,
        dismissActiveCpeMarker: dismissActiveMarker,
        setCpeMarkersReady: setCpeMarkersReady,
    };
};